<template>
	<v-menu offset-y eager>
		<template v-slot:activator="{ on, attrs }">
			<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
				<v-icon>mdi-dots-vertical</v-icon>
			</v-btn>
		</template>
		<v-list dense>
			<v-list-item link @click="$emit('edit', item)">
				<v-list-item-title class="size9">{{ aperto ? 'Modifica' : 'Apri' }}</v-list-item-title>
			</v-list-item>
			<v-list-item v-if="aperto" link @click="$emit('publish', item)">
				<v-list-item-title class="size9">Pubblica ora</v-list-item-title>
			</v-list-item>
			<v-list-item v-if="item.status === 'BOZZA' && item.publishedAt" link @click="$emit('status', item, 'PROGRAMMATO')">
				<v-list-item-title class="size9">Programma</v-list-item-title>
			</v-list-item>
			<v-list-item v-if="item.status === 'PROGRAMMATO' || item.status === 'BOZZA' || item.status === 'ERRORE'" link @click="$emit('status', item, 'ANNULLATO')">
				<v-list-item-title class="size9">Annulla</v-list-item-title>
			</v-list-item>
			<v-list-item v-if="item.status === 'ANNULLATO'" link @click="$emit('status', item, 'BOZZA')">
				<v-list-item-title class="size9">Riporta in bozza</v-list-item-title>
			</v-list-item>
			<v-divider></v-divider>
			<v-subheader class="sr-head">Scarica immagine</v-subheader>
			<v-list-item v-for="p in item.platforms" :key="p" link @click="$emit('download', item, principale[p])">
				<v-list-item-title class="size9">{{ social[p].label }}</v-list-item-title>
			</v-list-item>
			<template v-if="(item.outputs || []).length">
				<v-divider></v-divider>
				<v-subheader class="sr-head">Pubblicate</v-subheader>
				<v-list-item v-for="o in item.outputs" :key="o.format" link :href="o.url" target="_blank">
					<v-list-item-title class="size9">Immagine {{ social[o.platform] ? social[o.platform].label : o.platform }}</v-list-item-title>
				</v-list-item>
			</template>
			<v-divider></v-divider>
			<v-list-item link :disabled="item.status === 'IN_PUBBLICAZIONE'" @click="$emit('delete', item)">
				<v-list-item-title class="size9">Elimina</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
import { SOCIAL, modificabile } from './formato';

// formato usato per la pubblicazione di ogni social (come formats.PRINCIPALE nel backend)
const PRINCIPALE = { facebook: 'fb_square', instagram: 'ig_portrait', tiktok: 'tiktok_story' };

// menu a tre puntini di un post: le azioni dipendono dallo stato
export default {
	name: 'SocialRowMenu',
	props: {
		item: { type: Object, required: true },
	},
	data() {
		return { social: SOCIAL, principale: PRINCIPALE };
	},
	computed: {
		aperto() {
			return modificabile(this.item);
		},
	},
};
</script>

<style scoped>
.sr-head {
	height: 28px;
	font-size: 11px;
	text-transform: uppercase;
	letter-spacing: 0.4px;
}
</style>
